import * as Sentry from '@sentry/vue'

const safeURL = (value) => {
  if (typeof value !== 'string') return undefined
  try {
    const parsed = new URL(value, 'https://relative.invalid')
    return parsed.origin === 'https://relative.invalid' ? `/${parsed.pathname.split('/').filter(Boolean)[0] || ''}` : parsed.origin
  } catch (_) {
    return undefined
  }
}

export default function setupSentry(app) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  const env = process.env.VUE_APP_ENV

  if (!dsn || env === 'local') return

  Sentry.init({
    app,
    dsn,
    environment: env,
    release: process.env.VUE_APP_RELEASE || undefined,
    integrations: [],
    tracesSampleRate: 0,
    // Replay envelopes bypass beforeSend. Keep replay disabled until there is
    // an approved masking, retention and access policy.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event, hint) {
      const error = hint && hint.originalException
      if (error && error.response) {
        const status = error.response.status
        if (status === 401 || status === 404) return null
      }
      if (event.request) {
        delete event.request.cookies
        delete event.request.data
        if (event.request.headers) {
          delete event.request.headers.Authorization
          delete event.request.headers.authorization
          delete event.request.headers.Cookie
          delete event.request.headers.cookie
        }
        if (event.request.url) event.request.url = safeURL(event.request.url)
      }
      delete event.user
      if (event.exception && event.exception.values) {
        event.exception.values = event.exception.values.map((value) => ({ ...value, value: 'application error' }))
      }
      if (event.message) event.message = 'application error'
      const safeExtra = {}
      if (event.extra) {
        if (typeof event.extra.url === 'string') safeExtra.url = safeURL(event.extra.url)
        if (typeof event.extra.method === 'string') safeExtra.method = event.extra.method.slice(0, 12)
        if (typeof event.extra.status === 'number') safeExtra.status = event.extra.status
      }
      event.extra = safeExtra
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => ({
          category: 'application',
          level: breadcrumb.level,
          timestamp: breadcrumb.timestamp,
          type: breadcrumb.type,
          message: breadcrumb.category ? 'application breadcrumb' : undefined
        }))
      }
      return event
    }
  })
}
